import { AccessPermissions } from '@circlefin/permissions'
import { Role } from '@circlefin/permissions/roles'

import type { PermissionSet } from '@circlefin/permissions'

export const PAYOUTS: PermissionSet = {
  access: AccessPermissions.protected,
  excludeAny: [Role.HIDE_PAYOUT_TAB_ROLE],
}
